import { get } from 'lodash';
import { DEFAULT_LANGUAGE } from '@wix/communities-blog-universal/dist/src/constants/blog-languages';
export const getAppData = (state) => state.appData;
export const getFeedTitle = (state) => getAppData(state).menuLabel;
export const getLanguage = (state) => getAppData(state).language || DEFAULT_LANGUAGE;
export const getAmpEnabled = (state) => get(getAppData(state), 'ampEnabled', false);
export const getSchemaEnabled = (state) => get(getAppData(state), 'schemaEnabled', false);
export const getSendEmailsToSiteSubscribers = (state) => get(getAppData(state), 'sendEmailsToSiteSubscribers', false);
export const getSendEmailsToSiteMembers = (state) => get(getAppData(state), 'sendEmailsToSiteMembers', false);
//# sourceMappingURL=app-data-selectors.js.map